import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type WorkforceDemandMSProps = BaseNotificationItemProps & {
  msCountNeeded: number
  msCountAvailable: number
  type: 'workforce-demand-ms'
}

export function WorkforceDemandMS({ msCountNeeded, msCountAvailable, ...props }: WorkforceDemandMSProps) {
  return (
    <NotificationItem
      {...props}
      title='Workforce Demand Unmet'
      descriptionAddon={
        <p className='text-sm text-gray-500'>
          Mission Specialist Need:&nbsp; <b>{msCountNeeded}</b> &nbsp;|&nbsp; Online:&nbsp;{' '}
          <b>{msCountAvailable}</b>
        </p>
      }
    />
  )
}
